/**
 * The "Questions? Chat with …" card's display half (mockup .sd-prov): the business's
 * name, its line and the chat button. The Mini App feeds it from the client's
 * dashboard (DetailProviderCard); the studio website from its public studio read.
 */
import { ChatIcon } from '../detailIcons';
import styles from '../SessionDetailPage.module.css';

export function DetailProviderCardView({ businessName, line, onChat }: { businessName: string; line: string; onChat: () => void }) {
  return (
    <div className={styles.prov} data-testid="detail-provider">
      <span className={`${styles.avatar} ${styles.avatarBusiness}`} aria-hidden="true">
        {Array.from(businessName)[0]?.toUpperCase()}
      </span>
      <span className={styles.who}>
        <span className={styles.qk}>Questions? Chat with</span>
        <span className={styles.provName}>{businessName}</span>
        <span className={styles.provLine}>{line}</span>
      </span>
      <button type="button" className={styles.chat} onClick={onChat} aria-label={`Message ${businessName}`}>
        {ChatIcon}
      </button>
    </div>
  );
}
